module.exports = __webpack_public_path__ + "img/4-3.f24e5fad.png";